import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Leidsid mujalt soodsamalt? Küsi ON24'st veel paremat hinda

  <span style="color:#85c1dc;">**FI:**</span>
  Löysitkö edullisemmin muualta? Kysy ON24:ltä vielä parempaa hintaa

  <span style="color:#85c1dc;">**RU:**</span>
  Желаемый товар дешевле в другом магазине? Спроси у ON24 ещё более выгодную цену
*/
/* @__NO_SIDE_EFFECTS__ */
const m629 = msg(
  mf`Leidsid mujalt soodsamalt? Küsi ON24'st veel paremat hinda`,
  mf`Löysitkö edullisemmin muualta? Kysy ON24:ltä vielä parempaa hintaa`,
  mf`Желаемый товар дешевле в другом магазине? Спроси у ON24 ещё более выгодную цену`,
)

export { m629 as 'w.module.product.ask_price' }